/*
 * @Author: linhao hao.lin@biz-united.com.cn
 * @Date: 2026-10-09 16:48:56
 * @LastEditors: linhao hao.lin@biz-united.com.cn
 * @LastEditTime: 2026-10-09 16:49:25
 * @FilePath: \crm-product\found\views\cps\views\terminal_scan\warning_report\detail\detail.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import BasePage from '@/found/components/table_page';

export default {
  name: 'detail',
  extends: BasePage,
  props: {
    paramsProps: Object,
  },
  data() {
    return {
      params: {
        reportId: this.paramsProps.reportId,
      },
    };
  },
  methods: {},
  created() {
    this.getConfigList('detail-list');
  },
};
